module.exports = __webpack_public_path__ + "static/img/PIC.bbe18f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/PIC.png
// module id = 1ga/
// module chunks = 1